export const findCurrentLevel = (levels, amount) => (
  levels?.find((level, index) => {
    if ((amount >= level.min && amount <= level.max) || (index === levels.length - 1 && amount > level.max)) {
      return level;
    }

    return '';
  })
);
